import React from 'react'
import { Sierra, SierraLayouts } from '../../collections/Sierra/Sierra'
import { ContentDataDefinitionLoader } from '@news-mono/web-common'
import {
    CollectionRouteProps,
    calculateExpectedCardCountFromContentData,
} from '../../collections/collections-props.routing'
import { CardOrientationOptions } from '../../cards/Portrait/Portrait'
import { FixedRatio } from '@news-mono/web-common'
import { createRegisterableComponentWithData } from '@news-mono/web-common'
import { HeroVideoLayoutRatios } from '../../cards/HeroVideoCard/HeroVideoCard'
import { ResponsivePictureLayout } from '../../content/Picture/ResponsivePictureLayouts'
import { ResponsiveContainer } from '../../content/Picture/responsive'

export interface SierraRouteProps
    extends CollectionRouteProps,
        ResponsiveContainer {
    disableImageLazyLoad?: boolean
    fixedRatios?: FixedRatio[]
    cardOrientation?: CardOrientationOptions
    cardLayout: SierraLayouts
    heroImageLayout?: ResponsivePictureLayout
    heroVideoRatio?: HeroVideoLayoutRatios
}

export const SierraRegistration = createRegisterableComponentWithData(
    'sierra',
    ContentDataDefinitionLoader,
    (props: SierraRouteProps, data, services) => {
        return (
            <Sierra
                items={
                    data.loaded
                        ? { loaded: true, result: data.result.publications }
                        : { loaded: false }
                }
                expectedCards={calculateExpectedCardCountFromContentData(
                    data.dataDefinitionArgs,
                )}
                sectionHeader={props.sectionHeader}
                verticalSpacing={props.verticalSpacing}
                disableImageLazyLoad={props.disableImageLazyLoad}
                cardOrientation={props.cardOrientation}
                onEvent={services.onEvent}
                cardLayout={props.cardLayout}
                heroImageLayout={props.heroImageLayout}
                cardServices={services}
                heroVideoRatio={props.heroVideoRatio}
                containerWidthRatios={props.containerWidthRatios}
            />
        )
    },
)
